import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../_actions";
import { Banner, Item, ItemEmpty, List } from "../../_components/ListSnjob";
import { ModalSnjob } from "../../_components/ModalSnjob";
import { userConstants } from "../../_constants";
import { formatDate } from "../../_helpers/formatDate";
import "./css/pdp-super-admin.scss";
import dislikeLogo from "./img/dlike.webp";
import likeLogo from "./img/like.webp";
import emptyLogo from "./img/noselect.webp";
import replaceLogo from "./img/replace.webp";
import eyeLogo from "./img/seennews.webp";
import settingsLogo from "./img/settings.webp";
import tickDarkLogo from "./img/success-dark.webp";
import tickLogo from "./img/success.webp";
import waitingLogo from "./img/wating.webp";

export const PdpSuperAdmin = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.globalStorage);
  const [hospitals, setHospitals] = useState([]);
  const [requestedCoursesUser, setRequestedCoursesUser] = useState([]);
  const [requestedCoursesUsers, setRequestedCoursesUsers] = useState([]);
  const [usersListModal, setUsersListModal] = useState(false);
  const [userListModal, setUserListModal] = useState(false);
  const [transferModal, setTransferModal] = useState(false);
  const [activeHospital, setActiveHospital] = useState(null);
  const [activePerson, setActivePerson] = useState(null);
  const [transferId, setTransferId] = useState(null);

  useEffect(() => {
    getHospitals();
  }, []);

  useEffect(() => {
    if (activeHospital !== null) {
      getRequestedCoursesUsers();
    }
  }, [activeHospital]);

  useEffect(() => {
    if (activePerson !== null) {
      getRequestedCoursesUser();
    }
  }, [activePerson]);

  const getHospitals = () => {
    dispatch(userActions.API("get", `v1/hospitals`, null, true)).then((res) => {
      setHospitals(res.data);
    });
  };

  const changeSuperior = () => {
    requestedCoursesUser.forEach(({ id }) => {
      const data = {
        id,
        superior_id: +transferId,
      };

      dispatch(
        userActions.API(
          "put",
          `v1/su_admin/hospital/requested_courses/superior`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenSuperAdmin"))
        )
      ).then((res) => {
        userActions.successToast("با موفقیت ثبت شد");
        setTransferId(null);
        setTransferModal(false);
        setUsersListModal(true);
        getRequestedCoursesUser();
      });
    });
  };

  const getRequestedCoursesUsers = () => {
    dispatch(
      userActions.API(
        "get",
        `v1/su_admin/hospital/requested_courses/users?hospital_id=${activeHospital}`,
        null,
        true,
        false,
        JSON.parse(localStorage.getItem("tokenSuperAdmin"))
      )
    ).then((res) => {
      setRequestedCoursesUsers(res.data);
    });
  };

  const getRequestedCoursesUser = () => {
    dispatch(
      userActions.API(
        "get",
        `v1/su_admin/hospital/requested_courses?hospital_id=${activeHospital}&user_id=${activePerson}`,
        null,
        true,
        false,
        JSON.parse(localStorage.getItem("tokenSuperAdmin"))
      )
    ).then((res) => {
      setRequestedCoursesUser(res.data);
    });
  };

  return (
    <div className="PdpSuperAdmin">
      <div className="list-wrapper">
        <List className="transparent-scroll container-fluid px-0 py-4">
          <ul
            className="list position-relative w-100 m-0 p-2"
            style={{
              boxShadow: "none",
            }}
          >
            <Banner grid="1fr 2fr 4fr 1fr 1fr" style={{ zIndex: 1 }} key={0}>
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                ردیف
              </div>
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                لوگو
              </div>
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                نام بیمارستان
              </div>
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                شناسه بیمارستان
              </div>
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                عملیـات
              </div>
            </Banner>
            {hospitals?.map(({ name, logo, id }, i) => {
              return (
                <Item grid="1fr 2fr 4fr 1fr 1fr" key={i + 1}>
                  <div
                    className="d-flex justify-content-center align-items-center h-100 w-100"
                    style={{ gap: "10px" }}
                  >
                    <p className="itemComp__text text-center text-primary m-0">
                      {i + 1}
                    </p>
                  </div>
                  <div
                    className="d-flex justify-content-center align-items-center h-100 w-100"
                    style={{ gap: "10px" }}
                  >
                    <p className="itemComp__text m-0">
                      <img
                        className="img_pointy"
                        src={`${userConstants.SERVER_URL}${logo.url}`}
                        alt="hospital logo"
                      />
                    </p>
                  </div>
                  <div
                    className="d-flex justify-content-center align-items-center h-100 w-100"
                    style={{ gap: "10px" }}
                  >
                    {name}
                  </div>
                  <div
                    className="d-flex justify-content-center align-items-center h-100 w-100"
                    style={{ gap: "10px" }}
                  >
                    <p className="itemComp__text m-0">{id}</p>
                  </div>
                  <div
                    className="d-flex justify-content-center align-items-center h-100 w-100"
                    style={{ gap: "10px" }}
                  >
                    <button
                      className="btn rounded-circle p-0"
                      onClick={() => {
                        setActiveHospital(id);
                        setUsersListModal(true);
                      }}
                    >
                      <img src={settingsLogo} className="img_round" alt="" />
                    </button>
                  </div>
                </Item>
              );
            })}
          </ul>
        </List>
      </div>
      <ModalSnjob
        title="لطفاً بخش های بیمارستان را به همراه انتخاب یک مسئول انتخاب کنید"
        className="PdpSuperAdmin"
        isOpen={usersListModal}
        onClose={() => setUsersListModal(false)}
      >
        <List
          className="transparent-scroll"
          container="container-fluid"
          padding="px-0"
          style={{ height: "600px" }}
        >
          <ul
            className="list position-relative w-100 m-0 p-2"
            style={{
              boxShadow: "none",
            }}
          >
            <Banner
              grid="1fr 2fr 1fr 1fr 1fr 1fr"
              style={{ zIndex: 1 }}
              key={0}
            >
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                ردیف
              </div>
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                نام و نام خانوادگی
              </div>
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                محل خدمت
              </div>
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                سمت
              </div>
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                گروه شغلی
              </div>
              <div
                className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                style={{ fontSize: "12.6px" }}
              >
                عملیات
              </div>
            </Banner>
            {requestedCoursesUsers.length !== 0 ? (
              requestedCoursesUsers.map(
                ({ firstname, lastname, post, id }, i) => {
                  return (
                    <Item grid="1fr 2fr 1fr 1fr 1fr 1fr" key={i + 1}>
                      <div
                        className="d-flex justify-content-center align-items-center h-100 w-100"
                        style={{ gap: "10px" }}
                      >
                        <p className="itemComp__text text-center text-primary m-0">
                          {i + 1}
                        </p>
                      </div>
                      <div
                        className="d-flex justify-content-center align-items-center h-100 w-100"
                        style={{ gap: "10px" }}
                      >
                        <p className="itemComp__text text-center text-primary m-0">{`${firstname} ${lastname}`}</p>
                      </div>
                      <div
                        className="d-flex justify-content-center align-items-center h-100 w-100"
                        style={{ gap: "10px" }}
                      >
                        <p className="itemComp__text text-center text-primary m-0">
                          {post?.job_location}
                        </p>
                      </div>
                      <div
                        className="d-flex justify-content-center align-items-center h-100 w-100"
                        style={{ gap: "10px" }}
                      >
                        <p className="itemComp__text text-center text-primary m-0">
                          {post?.name}
                        </p>
                      </div>
                      <div
                        className="d-flex justify-content-center align-items-center h-100 w-100"
                        style={{ gap: "10px" }}
                      >
                        <p className="itemComp__text text-center text-primary m-0">
                          {post?.job_group}
                        </p>
                      </div>
                      <div
                        className="d-flex justify-content-center align-items-center h-100 w-100"
                        style={{ gap: "10px" }}
                      >
                        <button
                          className="btn rounded-circle p-0"
                          onClick={() => {
                            setActivePerson(id);
                            setUsersListModal(false);
                            setTransferModal(true);
                          }}
                        >
                          <img src={replaceLogo} className="img_round" alt="" />
                        </button>
                        <button
                          className="btn rounded-circle p-0"
                          onClick={() => {
                            setActivePerson(id);
                            setUsersListModal(false);
                            setUserListModal(true);
                          }}
                        >
                          <img src={eyeLogo} className="img_round" alt="" />
                        </button>
                      </div>
                    </Item>
                  );
                }
              )
            ) : (
              <ItemEmpty />
            )}
          </ul>
        </List>
      </ModalSnjob>
      {requestedCoursesUser.length !== 0 && (
        <ModalSnjob
          title={`${requestedCoursesUser[0].user?.firstname} ${requestedCoursesUser[0].user?.lastname} (${requestedCoursesUser[0].user.post?.job_group}) | ${requestedCoursesUser[0].superior?.firstname} ${requestedCoursesUser[0].superior?.lastname} (${requestedCoursesUser[0].ward?.name})`}
          className="PdpSuperAdmin"
          isOpen={transferModal}
          onClose={() => {
            setTransferModal(false);
            setUsersListModal(true);
          }}
        >
          <div className="w-100 px-3">
            <p className="text-right w-100 px-2 iran-sans_Bold">آیدی مافوق</p>
            <Textarea
              value={transferId}
              onChange={(e) => setTransferId(e.target.value)}
            />
          </div>
          <div className="row d-flex justify-content-center align-content-center">
            <button
              className="btn px-5 btn-primary mt-3 rounded-pill iran-sans_Bold"
              onClick={changeSuperior}
            >
              ثبت
            </button>
          </div>
        </ModalSnjob>
      )}
      {requestedCoursesUser.length !== 0 && (
        <ModalSnjob
          title={`${requestedCoursesUser[0].user?.firstname} ${requestedCoursesUser[0].user?.lastname} (${requestedCoursesUser[0].user.post?.job_group}) | ${requestedCoursesUser[0].superior?.firstname} ${requestedCoursesUser[0].superior?.lastname} (${requestedCoursesUser[0].ward?.name})`}
          className="PdpSuperAdmin"
          isOpen={userListModal}
          onClose={() => {
            setUserListModal(false);
            setUsersListModal(true);
          }}
        >
          {requestedCoursesUser[0].user_comment !== null &&
            requestedCoursesUser[0].user_comment.length !== 0 && (
              <div className="w-100 px-3">
                <p className="text-right w-100 px-2 iran-sans_Bold">{`توضیحاتی که کاربر در زمان ارسال درخواست داده است (${
                  requestedCoursesUser[0].submitted_at !== null
                    ? formatDate(requestedCoursesUser[0].submitted_at)
                    : "xxx"
                })`}</p>
                <Textarea
                  value={requestedCoursesUser[0].user_comment}
                  onChange={() => ""}
                />
              </div>
            )}
          <List
            className="transparent-scroll"
            container="container-fluid"
            padding="px-0"
            style={{ height: "600px" }}
          >
            <ul
              className="list position-relative w-100 m-0 p-2"
              style={{
                boxShadow: "none",
              }}
            >
              <Banner
                grid="1fr 3fr 1fr 1fr 1fr 1fr"
                style={{ zIndex: 1 }}
                key={0}
              >
                <div
                  className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                  style={{ fontSize: "12.6px" }}
                >
                  ردیف
                </div>
                <div
                  className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                  style={{ fontSize: "12.6px" }}
                >
                  عنوان
                </div>
                <div
                  className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                  style={{ fontSize: "12.6px" }}
                >
                  تاریخ ثبت
                </div>
                <div
                  className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                  style={{ fontSize: "12.6px" }}
                >
                  کاربر
                </div>
                <div
                  className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                  style={{ fontSize: "12.6px" }}
                >
                  مافوق
                </div>
                <div
                  className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                  style={{ fontSize: "12.6px" }}
                >
                  سوپروایزر
                </div>
              </Banner>
              {requestedCoursesUser
                .filter(({ user }) => user.id === activePerson)
                .map(
                  (
                    {
                      submitted_at,
                      status,
                      course,
                      requested_by,
                      superior_comment,
                      supervisor_comment,
                    },
                    i
                  ) => {
                    let userIcon = null;
                    let superiorIcon = null;
                    let supervisorIcon = null;

                    if (
                      requested_by === "user" &&
                      status === "superior_pending"
                    ) {
                      userIcon =
                        course.course_type === "2" ? tickDarkLogo : tickLogo;
                      superiorIcon =
                        course.course_type === "2" ? tickDarkLogo : waitingLogo;
                      supervisorIcon =
                        course.course_type === "2" ? tickDarkLogo : waitingLogo;
                    }
                    if (
                      requested_by === "user" &&
                      status === "supervisor_pending"
                    ) {
                      userIcon =
                        course.course_type === "2" ? tickDarkLogo : tickLogo;
                      superiorIcon =
                        course.course_type === "2"
                          ? tickDarkLogo
                          : superior_comment && superior_comment.length === 0
                          ? dislikeLogo
                          : likeLogo;
                      supervisorIcon =
                        course.course_type === "2" ? tickDarkLogo : waitingLogo;
                    }
                    if (
                      requested_by === "user" &&
                      status === "rejected_by_superior"
                    ) {
                      userIcon =
                        course.course_type === "2" ? tickDarkLogo : tickLogo;
                      superiorIcon =
                        course.course_type === "2" ? tickDarkLogo : dislikeLogo;
                      supervisorIcon =
                        course.course_type === "2" ? tickDarkLogo : waitingLogo;
                    }
                    if (
                      requested_by === "user" &&
                      status === "rejected_by_supervisor"
                    ) {
                      userIcon =
                        course.course_type === "2" ? tickDarkLogo : tickLogo;
                      superiorIcon =
                        course.course_type === "2"
                          ? tickDarkLogo
                          : superior_comment === null ||
                            superior_comment.length === 0
                          ? likeLogo
                          : dislikeLogo;
                      supervisorIcon =
                        course.course_type === "2" ? tickDarkLogo : dislikeLogo;
                    }
                    if (requested_by === "user" && status === "active") {
                      userIcon =
                        course.course_type === "2" ? tickDarkLogo : tickLogo;
                      superiorIcon =
                        course.course_type === "2"
                          ? tickDarkLogo
                          : superior_comment === null ||
                            superior_comment.length === 0
                          ? likeLogo
                          : dislikeLogo;
                      supervisorIcon =
                        course.course_type === "2" ? tickDarkLogo : likeLogo;
                    }
                    if (
                      requested_by === "superior" &&
                      status === "supervisor_pending"
                    ) {
                      userIcon = emptyLogo;
                      superiorIcon = tickLogo;
                      supervisorIcon = waitingLogo;
                    }
                    if (
                      requested_by === "superior" &&
                      status === "rejected_by_supervisor"
                    ) {
                      userIcon = emptyLogo;
                      superiorIcon = tickLogo;
                      supervisorIcon = dislikeLogo;
                    }
                    if (requested_by === "superior" && status === "active") {
                      userIcon = emptyLogo;
                      superiorIcon = tickLogo;
                      supervisorIcon = likeLogo;
                    }
                    if (requested_by === "supervisor" && status === "active") {
                      userIcon = emptyLogo;
                      superiorIcon = emptyLogo;
                      supervisorIcon = tickLogo;
                    }

                    return (
                      <Item grid="1fr 3fr 1fr 1fr 1fr 1fr" key={i + 1}>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <p className="itemComp__text text-center text-primary m-0">
                            {i + 1}
                          </p>
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <p className="itemComp__text text-center text-primary m-0">
                            {course.title}
                          </p>
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <p className="itemComp__text text-center text-primary m-0">
                            {submitted_at !== null && formatDate(submitted_at)}
                          </p>
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <button className="btn rounded-circle p-0">
                            <img src={userIcon} className="img_round" alt="" />
                          </button>
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <button className="btn rounded-circle p-0">
                            <img
                              src={superiorIcon}
                              className="img_round"
                              alt=""
                            />
                          </button>
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <button className="btn rounded-circle p-0">
                            <img
                              src={supervisorIcon}
                              className="img_round"
                              alt=""
                            />
                          </button>
                        </div>
                      </Item>
                    );
                  }
                )}
            </ul>
          </List>
        </ModalSnjob>
      )}
    </div>
  );
};

const Textarea = ({ className, placeholder, value, onChange }) => {
  return (
    <textarea
      className={`special_textarea ${className}`}
      placeholder={`${placeholder || ""}`}
      value={value || ""}
      onChange={onChange}
    />
  );
};
